import { useIntl } from 'react-intl'
import { connect, useDispatch, useSelector } from 'react-redux'
import SectionContainer from '../../Layout/SectionContainer/SectionContainer'
import TaskScheduling from './TaskScheduling/TaskScheduling'
import Action from '../Action/Action'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'
import {
    ActivitySection,
    NewActivitySectionType,
    NewTaskStepNavigation,
} from '@/app/models/new-activity-section-type'
import {
    addChangelog,
    createProject,
    editProject,
    historyChange,
    NewActivityCreationActions,
    removeChangelog,
    setActivitySectionStatus,
    setCtaTemplate,
    setCurrentStep,
    setIsActivityTypeStep,
    setNewActivityForm,
    setResetMandatory,
    setSelectedActivityType,
    setSmartFilterActivity,
    setSurveyStatus,
    setTaskStatus,
} from '@/app/redux/actions/activity-creation'
import TaskMainInfo from './TaskMainInfo/TaskMainInfo'
import { ActivityStep, Survey, Task } from '@/app/models/new-activity-creation-state'
import {
    DistributionForm,
    FormField,
    MainInfoForm,
    PointsAssignmentForm,
    SchedulingForm,
    SubActivityTypeForm,
    TaskForm,
} from '@/app/models/new-activity-form'
import { useEffect, useState } from 'react'
import { creationCta, editCta } from '@/app/models/new-activity-creation-cta'
import {
    Analytics,
    AppState,
    LayoutActivityType,
    SmartlyActionItems,
    SmartlyActionSubtypes,
} from '@Techedge/digitalportal-shared'
import EditingReason from '../EditingReason/EditingReason'
import {
    getActivityApi,
    getDateDiff,
    getEditProject,
    getEditSelectedStoreList,
} from '@/app/utils/activityAdapter'
import { ProjectApiCreateActivityBody, ProjectApiStatus } from '@/app/models/projects-service'
import DialogDuplicate from '../../UI/Dialogs/DialogDuplicate/DialogDuplicate'
import { CtaGroupWrapper } from '../../UI/CtaGroup/CtaGroupWrapper'
import { cancelProject, saveAsToBeReleased } from '@/app/redux/actions/activity-execution'
import DialogHistoryChange from '../../UI/Dialogs/DialogHistoryChange/DialogHistoryChange'
import DialogResetStore from '../../UI/Dialogs/DialogResetStore/DialogResetStore'
import { creationAnalyticsPageTypeMap } from '@/app/models/analyticsPageTypeMap'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@redux/reducers/activity-execution'
import { TaskSubType } from '@/app/models/task'
import PhotographicTaskAction from '../Action/PhotographicTaskAction'
import { SectionFilter } from '@/app/models/search'
import SectionBox from '../../Layout/SectionBox/SectionBox'
import { Color, LuxButton } from '@lux/wardrobe-lib'
import './NewActivityTask.scss'
import { selectCurrentStep } from '@/app/redux/selector/activity-creation'
import { PointsAssignments } from '../PointsAssignment/PointsAssignments'
import DistributionList from '../Distribution/DistributionList'
import { DistributionApprovers } from '../Distribution/DistributionApprovers'

const NewActivityTask = (props: any) => {
    const {
        form,
        setForm,
        sectionMap,
        setActivitySectionStatus,
        projectVisibilityOptions,
        setCtaTemplate,
        questionList,
        taskList,
        surveyList,
        projectDetails,
        setActionTaskList,
        setActionSurveyList,
        isEdit,
        createProject,
        isClone,
        saveAsToBeReleased,
        cancelProject,
        storeIdList,
        historyChange,
        changeFields,
        editProject,
        isResetMandatory,
        setResetMandatory,
        activityTypeList,
        storesList,
        smartFilter,
        setSmartFilter,
    } = props

    const intl = useIntl()
    const dispatch = useDispatch()
    const step = useSelector(selectCurrentStep)
    const hasSocialHubEnabled = useSelector(
        (state: AppState) => state.userReducer.user.phase3_enabled
    )

    const componentClass = 'smart-new-activity-task'

    const [showDuplicateDialog, setShowDuplicateDialog] = useState(false)
    const [showHistoryChangeDialog, setShowHistoryChangeDialog] = useState(false)

    const [reasonWhy, setReasonWhy] = useState('')
    const [editingReason, setEditingReason] = useState('')
    const [messageForStores, setMessageForStore] = useState('')

    const [editStatusAction, setEditStatusAction] = useState('')
    const [isActionDirty, setIsActionDirty] = useState(isEdit)

    const ctaHandler = (action: string, form) => {
        let newProjectDetails
        switch (action) {
            case NewActivityCreationActions.CREATE_AS_TO_BE_RELEASED:
                createProject(
                    getActivityApi(form, ProjectApiStatus.TO_BE_RELEASED, SmartlyActionItems.TASK),
                    intl.formatMessage({
                        id: 'modals.activity.create.conclude.success.message',
                        defaultMessage: 'Project created successfully!',
                    })
                )
                break
            case NewActivityCreationActions.CREATE_AS_DRAFT:
                createProject(
                    getActivityApi(form, ProjectApiStatus.DRAFT, SmartlyActionItems.TASK),
                    intl.formatMessage({
                        id: 'modals.activity.create.draft.success.message',
                        defaultMessage: 'Project saved as draft successfully!',
                    }),
                    intl.formatMessage({
                        id: 'modals.activity.create.draft.error.message',
                        defaultMessage:
                            'You need to complete all required fields across the entire flow before saving as draft.',
                    })
                )
                break
            case NewActivityCreationActions.SAVE_AS_TO_BE_RELEASED:
                saveAsToBeReleased(
                    projectDetails.id,
                    intl.formatMessage({
                        id: 'modals.activity.create.conclude.success.message',
                        defaultMessage: 'Project created successfully!',
                    }),
                    storeIdList
                )
                break
            case NewActivityCreationActions.CLONE:
                setShowDuplicateDialog(true)
                break
            case NewActivityCreationActions.CANCEL:
                cancelProject(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.approval.cancel.success.message',
                        defaultMessage: 'Store redo successfully!',
                    })
                )
                break
            case NewActivityCreationActions.HISTORY_CHANGE:
                newProjectDetails = getEditProject(form, projectDetails)
                historyChange({ ...newProjectDetails })
                Analytics._sendAnalyticsLinkEvent(
                    'Activities',
                    creationAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                        .history,
                    'Static'
                )
                setShowHistoryChangeDialog(true)
                break
            case NewActivityCreationActions.EDIT_RELEASE:
                setEditStatusAction('released')
                newProjectDetails = getEditProject(form, projectDetails)
                historyChange(
                    { ...newProjectDetails },
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    'released'
                )
                break
            case NewActivityCreationActions.EDIT_SAVE_AS_DRAFT:
                setEditStatusAction('draft')
                newProjectDetails = getEditProject(form, projectDetails)
                const statusAction = newProjectDetails.status !== 'draft' ? 'draft' : ''
                historyChange(
                    { ...newProjectDetails },
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    statusAction
                )
                break
            case NewActivityCreationActions.EDIT_SAVE_AS_TO_BE_RELEASED:
                setEditStatusAction('toBeReleased')
                newProjectDetails = getEditProject(form, projectDetails)
                historyChange(
                    { ...newProjectDetails },
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    'toBeReleased'
                )
                break
        }
    }

    const handlerEditProject = (confirm) => {
        if (!confirm) {
            setResetMandatory(false)
            return
        }

        let newForm = { ...form, questionList, taskList, surveyList, smartFilter }

        const newProjectDetails = getEditProject(newForm, projectDetails)
        editProject(
            newProjectDetails,
            reasonWhy,
            editingReason,
            messageForStores,
            intl.formatMessage({
                id: 'modals.activity.create.edit.success.message',
                defaultMessage: 'Project edit successfully!',
            }),
            editStatusAction
        )
    }

    const onDuplicateConfirm = (confirm: boolean) => {
        if (confirm) {
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: false }
            )
            taskList.map((task, index) => {
                setActionTaskList(index, {
                    ...task,
                    startDate: null,
                    endDate: null,
                })
            })
            surveyList.map((survey, index) => {
                setActionSurveyList(index, {
                    ...survey,
                    startDate: null,
                    endDate: null,
                })
            })
            setForm(
                {
                    title: {
                        ...form[NewActivitySectionType.MAIN_INFO].title,
                        value: `${form[NewActivitySectionType.MAIN_INFO].title.value} - Copy`,
                    },
                },
                NewActivitySectionType.MAIN_INFO,
                ActivitySection.TASK_ACTIVITY
            )
            setForm(
                {
                    startDate: {
                        ...form[NewActivitySectionType.SCHEDULING].startDate,
                        value: null,
                    },
                    endDate: {
                        ...form[NewActivitySectionType.SCHEDULING].endDate,
                        value: null,
                    },
                    specificDate: {
                        ...form[NewActivitySectionType.SCHEDULING].specificDate,
                        value: null,
                    },
                },
                NewActivitySectionType.SCHEDULING,
                ActivitySection.TASK_ACTIVITY
            )
        }
        setShowDuplicateDialog(false)
    }

    const getSectionActionStatusDone = () => {
        if (isClone) {
            return (
                (!projectDetails.jobs || !projectDetails.jobs?.length) &&
                (!projectDetails.survey || !projectDetails.survey?.length)
            )
        }
        return true
    }

    useEffect(() => {
        if (projectDetails && activityTypeList.length) {
            setForm(
                {
                    type: {
                        ...form[NewActivitySectionType.TASK_TYPE].type,
                        value: projectDetails.type,
                        label: activityTypeList
                            .find((a) => a.key === SmartlyActionItems.TASK)
                            ?.subTypes.find((t) => t.value === projectDetails.type)?.label,
                        oldValue: projectDetails.type,
                    },
                    photoType: projectDetails.childrenSubType,
                },
                NewActivitySectionType.TASK_TYPE,
                ActivitySection.TASK_ACTIVITY
            )
        }
    }, [activityTypeList, projectDetails])

    useEffect(() => {
        const disabled = false
        if (projectDetails) {
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.EDITING_REASON,
                { isDone: projectDetails?.reasonChange?.value?.length > 0 }
            )
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.TASK_TYPE,
                { isDone: isClone || isEdit }
            )
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.MAIN_INFO,
                { isDone: isClone || isEdit }
            )
            setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.ACTION, {
                isDone: getSectionActionStatusDone(),
                isHide: projectDetails.requiredConfirmReading,
                isDisabled: disabled,
                isDirty:
                    (isClone || isEdit) &&
                    projectDetails.type !== SmartlyActionSubtypes.PICTURE_MGMT,
            })
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.DISTRIBUTION,
                { isDone: isClone || isEdit }
            )
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.POINTS_ASSIGNMENT,
                { isDone: (isClone || isEdit) && !!projectDetails.badge }
            )
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: isEdit, isDirty: isClone }
            )
            const tempTitle = isClone
                ? `${projectDetails.projectTitle} - Copy`
                : projectDetails.projectTitle
            const attachments = []
            if (!!projectDetails.attachments)
                projectDetails.attachments.forEach((attachment) => {
                    if (attachment)
                        attachments.push({
                            _id: attachment._id,
                            file: attachment,
                            url: !!attachment && attachment.url,
                            // hideEyeIcon: true,
                        })
                })
            const recursiveInfoType = projectDetails.recursiveInfo?.daily
                ? { daily: projectDetails.recursiveInfo?.daily }
                : null || projectDetails.recursiveInfo?.weekly
                ? { weekly: projectDetails.recursiveInfo?.weekly }
                : null || projectDetails.recursiveInfo?.monthly
                ? { monthly: projectDetails.recursiveInfo?.monthly }
                : null || projectDetails.recursiveInfo?.annual
                ? { annual: projectDetails.recursiveInfo?.annual }
                : null
            setForm(
                {
                    title: {
                        ...form[NewActivitySectionType.MAIN_INFO].title,
                        value: tempTitle,
                        disabled,
                    },
                    department: {
                        ...form[NewActivitySectionType.MAIN_INFO].department,
                        value: projectDetails.department,
                        disabled,
                    },
                    recipient: {
                        ...form[NewActivitySectionType.MAIN_INFO].recipient,
                        value: projectDetails?.assignment?.filter(
                            (a, i) => projectDetails?.assignment?.indexOf(a) === i
                        ),
                        disabled,
                    },
                    info: {
                        ...form[NewActivitySectionType.MAIN_INFO].info,
                        value: projectDetails.information,
                        disabled,
                    },
                    attachmentList: {
                        ...form[NewActivitySectionType.MAIN_INFO].attachmentList,
                        value: [...attachments],
                        disabled,
                    },
                    confirmRead: {
                        ...form[NewActivitySectionType.MAIN_INFO].confirmRead,
                        value: projectDetails.requiredConfirmReading,
                        disabled,
                    },
                    messagingEnabled: {
                        ...form[NewActivitySectionType.MAIN_INFO].messagingEnabled,
                        value: projectDetails.enableMessaging,
                        disabled,
                    },
                    commentReaction: {
                        ...form[NewActivitySectionType.MAIN_INFO].commentReaction,
                        disabled,
                    },
                },
                NewActivitySectionType.MAIN_INFO,
                ActivitySection.TASK_ACTIVITY
            )
            setForm(
                {
                    selectedStoreList: {
                        ...form[NewActivitySectionType.DISTRIBUTION].selectedStoreList,
                        value: storesList.map((s) => ({
                            ...s,
                            store_id: s.storeId,
                        })),
                        disabled,
                    },
                    selectedDistributionList: {
                        ...form[NewActivitySectionType.DISTRIBUTION].selectedDistributionList,
                        disabled,
                    },
                    listName: {
                        ...form[NewActivitySectionType.DISTRIBUTION].listName,
                        disabled,
                    },
                    approversList: projectDetails?.approvers,
                    approvalRequired: projectDetails?.approverRequired,
                },
                NewActivitySectionType.DISTRIBUTION,
                ActivitySection.TASK_ACTIVITY
            )
            setForm(
                {
                    badge: {
                        ...form[NewActivitySectionType.POINTS_ASSIGNMENT].badge,
                        value: {
                            id: projectDetails.badge?._id,
                            points: projectDetails.badge?.points,
                        },
                    },
                    points: {
                        ...form[NewActivitySectionType.POINTS_ASSIGNMENT].badge,
                        value: projectDetails.badge?.activityPoints,
                    },
                },
                NewActivitySectionType.POINTS_ASSIGNMENT,
                ActivitySection.TASK_ACTIVITY
            )
            setSmartFilter(projectDetails?.smartFilter)
            setForm(
                {
                    numberOfPhotos: projectDetails.numberOfPhotos,
                },
                NewActivitySectionType.ACTION,
                ActivitySection.TASK_ACTIVITY
            )
            setForm(
                {
                    startDate: {
                        ...form[NewActivitySectionType.SCHEDULING].startDate,
                        value:
                            !isClone && projectDetails.startDate > 0
                                ? new Date(projectDetails.startDate)
                                : null,
                        disabled,
                    },
                    endDate: {
                        ...form[NewActivitySectionType.SCHEDULING].endDate,
                        value:
                            !isClone && projectDetails.endDate > 0
                                ? new Date(projectDetails.endDate)
                                : null,
                        disabled,
                    },
                    projectVisibility: {
                        ...form[NewActivitySectionType.SCHEDULING].projectVisibility,
                        value: projectDetails.visibility,
                        disabled,
                    },
                    daysBefore: {
                        ...form[NewActivitySectionType.SCHEDULING].daysBefore,
                        value: getDateDiff(projectDetails.visibilityDate, projectDetails.startDate),
                        disabled,
                    },
                    specificDate: {
                        ...form[NewActivitySectionType.SCHEDULING].specificDate,
                        value:
                            !isClone && projectDetails.visibility === 'specificDate'
                                ? new Date(projectDetails.visibilityDate)
                                : null,
                        disabled,
                    },
                    priority: {
                        ...form[NewActivitySectionType.SCHEDULING].priority,
                        value: projectDetails.priority,
                        disabled,
                    },
                    autoClose: {
                        ...form[NewActivitySectionType.SCHEDULING].autoClose,
                        value: projectDetails.autoclose,
                        disabled,
                    },
                    autoCloseDays: {
                        ...form[NewActivitySectionType.SCHEDULING].autoCloseDays,
                        value: projectDetails.autocloseDate
                            ? getDateDiff(projectDetails.endDate, projectDetails.autocloseDate)
                            : null,
                        disabled,
                    },
                    calendarVisibility: {
                        ...form[NewActivitySectionType.SCHEDULING].calendarVisibility,
                        value: projectDetails.visibilityCalendar,
                        disabled,
                    },
                    recurring: {
                        ...form[NewActivitySectionType.SCHEDULING].recurring,
                        value: projectDetails.isRecursive,
                        disabled,
                    },
                    recurringType: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringType,
                        value: !!recursiveInfoType ? Object.keys(recursiveInfoType)[0] : null,
                        disabled,
                    },
                    recurringEvery: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringEvery,
                        value: !!recursiveInfoType
                            ? recursiveInfoType[Object.keys(recursiveInfoType)[0]].timeInterval
                            : null,
                        disabled,
                    },
                    recurringOn: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringOn,
                        value: !!recursiveInfoType
                            ? recursiveInfoType[Object.keys(recursiveInfoType)[0]].day
                            : null,
                        disabled,
                    },
                    recurringStartDate: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringStartDate,
                        value: projectDetails.recursiveInfo?.recursiveDateTimeFrom
                            ? new Date(projectDetails.recursiveInfo?.recursiveDateTimeFrom)
                            : null,
                        disabled,
                    },
                    recurringEndDate: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringEndDate,
                        value: projectDetails.recursiveInfo?.recursiveDateTimeTo
                            ? new Date(projectDetails.recursiveInfo?.recursiveDateTimeTo)
                            : null,
                        disabled,
                    },
                    recurringOccurrency: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringOccurrency,
                        value: projectDetails.recursiveInfo?.endOccurrences || null,
                        disabled,
                    },
                    recurringUntil: {
                        ...form[NewActivitySectionType.SCHEDULING].recurringUntil,
                        value: !projectDetails.isRecursive
                            ? null
                            : projectDetails.recursiveInfo?.noDeadline
                            ? 'endless'
                            : projectDetails.recursiveInfo?.recursiveDateTimeTo
                            ? 'until'
                            : 'after',
                        disabled,
                    },
                },
                NewActivitySectionType.SCHEDULING,
                ActivitySection.TASK_ACTIVITY
            )
            setForm(
                {
                    reasonWhy: { value: projectDetails.reasonChoice },
                    editingReason: { value: projectDetails.reasonChange },
                    messageForStores: { value: projectDetails.messageStores },
                },
                NewActivitySectionType.EDITING_REASON,
                ActivitySection.TASK_ACTIVITY
            )

            setReasonWhy(projectDetails.reasonChoice)
            setEditingReason(projectDetails.reasonChange)
            setMessageForStore(projectDetails.messageStores)

            if (projectDetails.surveys)
                projectDetails.surveys.forEach((survey, index) => {
                    let newSurvey: any = {
                        title: survey.title,
                        description: survey.details,
                        urgent: survey.priority === 'urgent',
                        startDate: !isClone ? new Date(survey.startDate) : null,
                        endDate: !isClone ? new Date(survey.endDate) : null,
                        recipient: projectDetails?.surveys[index].assignment,
                        selectedSurveyList: { surveyId: survey.surveyId },
                        attachmentList: survey.attachments
                            ? survey.attachments.map((attachment) => ({
                                  _id: attachment._id,
                                  file: attachment,
                                  url: !!attachment && attachment.url,
                                  hideEyeIcon: true,
                              }))
                            : [],
                        isDone: true,
                        _id: survey._id,
                    }
                    setActionSurveyList(index, newSurvey)
                })
        }
    }, [projectDetails])

    const isFormValid = () => {
        let isActionComplete = false
        switch (form.subType.type?.value) {
            case SmartlyActionSubtypes.COMMUNICATION:
                isActionComplete =
                    !questionList.filter((q) => !q.isDone).length &&
                    !taskList.filter((t) => !t.isDone || !t.startDate || !t.endDate).length &&
                    !surveyList.filter((s) => !s.isDone || !s.startDate || !s.endDate).length
                break
            case SmartlyActionSubtypes.SERVICE_REQUEST:
                isActionComplete =
                    questionList.filter((q) => q.isDone).length ||
                    taskList.filter((t) => t.isDone && t.startDate && t.endDate).length ||
                    surveyList.filter((s) => s.isDone && s.startDate && s.endDate).length ||
                    (!questionList.length && !taskList.length && !surveyList.length)
                break
            case SmartlyActionSubtypes.PICTURE_MGMT:
                isActionComplete = !!form.action?.numberOfPhotos
                break
            default:
                break
        }
        const badgeDisabled =
            !hasSocialHubEnabled ||
            (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id)
        const badgePoints =
            form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.points ||
            Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value)
        return (
            !!form[NewActivitySectionType.MAIN_INFO].title.value &&
            !!(
                form[NewActivitySectionType.MAIN_INFO].department.value ||
                form.subType.type?.value === SmartlyActionSubtypes.PICTURE_MGMT
            ) &&
            !!form[NewActivitySectionType.MAIN_INFO].recipient.value &&
            form[NewActivitySectionType.DISTRIBUTION].selectedStoreList.value.length > 0 &&
            (badgeDisabled ||
                (Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) > 0 &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) <=
                        badgePoints)) &&
            !!form[NewActivitySectionType.SCHEDULING].startDate.value &&
            !!form[NewActivitySectionType.SCHEDULING].endDate.value &&
            !!form[NewActivitySectionType.SCHEDULING].projectVisibility.value &&
            !!form[NewActivitySectionType.SCHEDULING].priority.value &&
            (!form[NewActivitySectionType.SCHEDULING].recurring.value ||
                (form[NewActivitySectionType.SCHEDULING].recurring.value &&
                    form[NewActivitySectionType.SCHEDULING].recurringType.value &&
                    form[NewActivitySectionType.SCHEDULING].recurringEvery.value > 0 &&
                    form[NewActivitySectionType.SCHEDULING].recurringUntil.value &&
                    form[NewActivitySectionType.SCHEDULING].recurringStartDate.value)) &&
            isActionComplete &&
            (projectDetails?.status === 'draft' ||
                projectDetails?.status === 'rejected' ||
                !isEdit ||
                (isEdit && reasonWhy && editingReason))
        )
    }

    const onNextStep = () => {
        if (step === NewActivitySectionType.MAIN_INFO && form.mainInfo.confirmRead.value) {
            dispatch(setCurrentStep(NewActivitySectionType.DISTRIBUTION))
            return
        }
        if (
            step === NewActivitySectionType.DISTRIBUTION &&
            (!hasSocialHubEnabled ||
                (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id))
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.SCHEDULING))
            return
        }
        dispatch(setCurrentStep(NewTaskStepNavigation[step].next))
    }
    const onBackStep = () => {
        if (step === NewActivitySectionType.EDITING_REASON) {
            dispatch(setSelectedActivityType({ key: LayoutActivityType.TASK }))
            dispatch(setIsActivityTypeStep(true))
            dispatch(setCurrentStep(NewActivitySectionType.ACTIVITY_TYPE))
            return
        }
        if (step === NewActivitySectionType.DISTRIBUTION && form.mainInfo.confirmRead.value) {
            dispatch(setCurrentStep(NewActivitySectionType.MAIN_INFO))
            return
        }
        if (
            !NewTaskStepNavigation[step].back &&
            isEdit &&
            projectDetails?.status !== SectionFilter.draft &&
            projectDetails?.status !== SectionFilter.rejected
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.EDITING_REASON))
            return
        }
        if (
            step === NewActivitySectionType.SCHEDULING &&
            (!hasSocialHubEnabled ||
                (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id))
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.DISTRIBUTION))
            return
        }
        if (!NewTaskStepNavigation[step].back) {
            dispatch(setSelectedActivityType({ key: LayoutActivityType.TASK }))
            dispatch(setIsActivityTypeStep(true))
            dispatch(setCurrentStep(NewActivitySectionType.ACTIVITY_TYPE))
            return
        }
        dispatch(setCurrentStep(NewTaskStepNavigation[step].back))
    }

    useEffect(() => {
        dispatch(
            setCurrentStep(
                isEdit &&
                    projectDetails?.status !== SectionFilter.draft &&
                    projectDetails?.status !== SectionFilter.rejected
                    ? NewActivitySectionType.EDITING_REASON
                    : NewActivitySectionType.MAIN_INFO
            )
        )
    }, [])

    useEffect(() => {
        if (step !== NewActivitySectionType.SCHEDULING)
            setCtaTemplate(
                <div className={`${componentClass}__cta-step`}>
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'back',
                            defaultMessage: 'Back',
                        })}
                        variant="text"
                        color={Color.BLACK}
                        onClick={onBackStep}
                    />
                    <div className={`${componentClass}__cta-step-right`}>
                        <LuxButton
                            text={intl.formatMessage({
                                id: 'modals.new.activity.creation.cta.save.as.draft',
                                defaultMessage: 'Save as draft',
                            })}
                            variant="outlined"
                            onClick={() =>
                                ctaHandler(NewActivityCreationActions.CREATE_AS_DRAFT, form)
                            }
                            disabled={!isFormValid()}
                        />
                        <LuxButton
                            text={intl.formatMessage({
                                id: 'next',
                                defaultMessage: 'Next',
                            })}
                            color={Color.BLACK}
                            onClick={onNextStep}
                            disabled={!sectionMap[step]?.isDone}
                        />
                    </div>
                </div>
            )
    }, [step, sectionMap, form])

    useEffect(() => {
        // PERMISSION CTA
        const ctaConfig = !isEdit
            ? creationCta(
                  SmartlyActionItems.TASK,
                  projectDetails?._id
                      ? { ...projectDetails, status: !isClone ? projectDetails.status : null }
                      : { type: form?.subType?.type?.value }
              ).setDisableConditions([
                  {
                      action: NewActivityCreationActions.CREATE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.SAVE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.SAVE_AS_DRAFT,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.CREATE_AS_DRAFT,
                      disableCondition: !isFormValid(),
                  },
              ])
            : editCta(
                  SmartlyActionItems.TASK,
                  projectDetails?._id ? projectDetails : { type: form?.subType?.type?.value }
              ).setDisableConditions([
                  {
                      action: NewActivityCreationActions.EDIT_RELEASE,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.EDIT_SAVE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
              ])

        const newForm = { ...form, questionList, taskList, surveyList, smartFilter }

        if (step === NewActivitySectionType.SCHEDULING) {
            setCtaTemplate(
                <div className={`${componentClass}__cta-step`}>
                    <LuxButton
                        text="Back"
                        variant="text"
                        color={Color.BLACK}
                        onClick={onBackStep}
                    />
                    <div className="smart-modals-cta-group-wrapper">
                        <CtaGroupWrapper
                            ctaConfig={ctaConfig}
                            componentClass={componentClass}
                            ctaHandler={(action) => ctaHandler(action, newForm)}
                        />
                    </div>
                </div>
            )
        }
    }, [
        form,
        questionList,
        taskList,
        surveyList,
        projectDetails,
        reasonWhy,
        editingReason,
        smartFilter,
    ])

    useEffect(() => {
        if (projectDetails?.type !== SmartlyActionSubtypes.PICTURE_MGMT) {
            setIsActionDirty(isActionDirty || step === NewActivitySectionType.ACTION)
            const isDone =
                !questionList.filter((q) => !q.isDone).length &&
                !taskList.filter((t) => !t.isDone || !t.startDate || !t.endDate).length &&
                !surveyList.filter((s) => !s.isDone || !s.startDate || !s.endDate).length
            setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.ACTION, {
                isDone: isDone && isActionDirty,
            })
        }
    }, [questionList, taskList, surveyList, projectDetails, step, isActionDirty])

    useEffect(() => {
        const tmpValues = Object.values(form[NewActivitySectionType.MAIN_INFO]).map(
            (field: FormField<any>, index: number) => {
                //index === 1 is department field, !mandatory only on photographic task
                if (index === 1 && form.subType.type.value === SmartlyActionSubtypes.PICTURE_MGMT) {
                    return { ...field, mandatory: false }
                } else {
                    return field
                }
            }
        )
        const isDone = !tmpValues.filter(
            (field: FormField<any>) => field.mandatory && (!field.value || !field.value?.length)
        ).length
        setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.MAIN_INFO, {
            isDone,
        })
    }, [form[NewActivitySectionType.MAIN_INFO]])

    useEffect(() => {
        setForm(
            {
                reasonWhy: {
                    value: reasonWhy?.length > 0 ? reasonWhy : projectDetails?.reasonChoice,
                },
                editingReason: {
                    value: editingReason?.length > 0 ? editingReason : projectDetails?.reasonChange,
                },
                messageForStores: {
                    value:
                        messageForStores?.length > 0
                            ? messageForStores
                            : projectDetails?.messageStores,
                },
            },
            NewActivitySectionType.EDITING_REASON,
            ActivitySection.TASK_ACTIVITY
        )

        let isDone = false

        if (editingReason?.length > 0 && reasonWhy?.length > 0) {
            isDone = true
        }

        setActivitySectionStatus(
            ActivitySection.TASK_ACTIVITY,
            NewActivitySectionType.EDITING_REASON,
            { isDone }
        )
    }, [reasonWhy, editingReason, messageForStores])

    useEffect(() => {
        const badgePoints =
            form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.points ||
            Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value)
        setActivitySectionStatus(
            ActivitySection.TASK_ACTIVITY,
            NewActivitySectionType.POINTS_ASSIGNMENT,
            {
                isDone:
                    !!form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) > 0 &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) <=
                        badgePoints,
            }
        )
    }, [form[NewActivitySectionType.POINTS_ASSIGNMENT]])

    const onAction = () => {
        setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.ACTION, {
            isDirty: true,
            isDone: false,
        })
    }

    const onSectionSave = (sectionKey: NewActivitySectionType) => {
        setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, sectionKey, { isDone: true })
    }

    const onTaskTypeChange = (partialForm: Partial<SubActivityTypeForm>) => {
        const isPhotographicType = partialForm.type?.value === SmartlyActionSubtypes.PICTURE_MGMT
        setForm(partialForm, NewActivitySectionType.TASK_TYPE, ActivitySection.TASK_ACTIVITY)
        setForm(
            {
                confirmRead: {
                    ...form[NewActivitySectionType.MAIN_INFO].confirmRead,
                    value: isPhotographicType
                        ? false
                        : form[NewActivitySectionType.MAIN_INFO].confirmRead.value,
                    hide: isPhotographicType,
                },
            },
            NewActivitySectionType.MAIN_INFO,
            ActivitySection.TASK_ACTIVITY
        )
        let isDone: boolean
        if (!!partialForm.type && (!isPhotographicType || !!partialForm.photoType)) isDone = true

        setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.TASK_TYPE, {
            isDone,
        })
    }

    const onMainInfoChange = (partialForm: Partial<MainInfoForm>) => {
        setForm(partialForm, NewActivitySectionType.MAIN_INFO, ActivitySection.TASK_ACTIVITY)
    }
    const onPointsAssignment = (partialForm: Partial<PointsAssignmentForm>) => {
        setForm(
            partialForm,
            NewActivitySectionType.POINTS_ASSIGNMENT,
            ActivitySection.TASK_ACTIVITY
        )
    }

    const onDistributionChange = (partialForm: Partial<DistributionForm>) => {
        setForm(partialForm, NewActivitySectionType.DISTRIBUTION, ActivitySection.TASK_ACTIVITY)
        let isDone
        if (
            partialForm.selectedStoreList.value.length > 0 &&
            (!(
                form[NewActivitySectionType.TASK_TYPE].type?.value ===
                    SmartlyActionSubtypes.PICTURE_MGMT && form.distribution.approvalRequired
            ) ||
                form.distribution.approversList?.length > 0) &&
            (!(
                form[NewActivitySectionType.TASK_TYPE].type?.value ===
                SmartlyActionSubtypes.SERVICE_REQUEST
            ) ||
                (form[NewActivitySectionType.TASK_TYPE].type?.value ===
                    SmartlyActionSubtypes.SERVICE_REQUEST &&
                    partialForm?.approversList?.length))
        )
            isDone = true
        setActivitySectionStatus(
            ActivitySection.TASK_ACTIVITY,
            NewActivitySectionType.DISTRIBUTION,
            { isDone }
        )
    }

    const onSchedulingChange = (partialForm: Partial<SchedulingForm>) => {
        setForm(partialForm, NewActivitySectionType.SCHEDULING, ActivitySection.TASK_ACTIVITY)
        let isDone
        if (
            partialForm.startDate.value &&
            partialForm.endDate.value &&
            partialForm.priority.value &&
            partialForm.projectVisibility.value &&
            (partialForm.projectVisibility.value !== projectVisibilityOptions[3].value ||
                (partialForm.projectVisibility.value === projectVisibilityOptions[3].value &&
                    partialForm.specificDate.value))
        )
            isDone = true
        setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.SCHEDULING, {
            isDone,
        })
    }

    const onChangeNumberOfPhotos = (val: number) =>
        setForm(
            { ...form, numberOfPhotos: val },
            NewActivitySectionType.ACTION,
            ActivitySection.TASK_ACTIVITY
        )

    const onChangeNumber = (value) => {
        onChangeNumberOfPhotos(value)
        if (value) onSectionSave(NewActivitySectionType.ACTION)
        else onAction()
    }

    return (
        <div className={componentClass}>
            <SectionContainer>
                {step === NewActivitySectionType.EDITING_REASON && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.task.section.editing.reason',
                            defaultMessage: 'Editing Reason',
                        })}>
                        <EditingReason
                            projectType={projectDetails?.projectType}
                            reasonWhy={reasonWhy}
                            editingReason={editingReason}
                            messageForStores={messageForStores}
                            onReasonWhy={setReasonWhy}
                            onEditingReason={setEditingReason}
                            onMessage={setMessageForStore}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.MAIN_INFO && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info',
                            defaultMessage: 'Main Information',
                        })}>
                        <TaskMainInfo
                            form={{
                                ...form[NewActivitySectionType.MAIN_INFO],
                                type: { ...form.subType?.type },
                            }}
                            activityTypeList={activityTypeList}
                            onSetForm={(form) => onMainInfoChange(form)}
                            onTaskTypeChange={(form) => onTaskTypeChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.MAIN_INFO)}
                            isDone={sectionMap[NewActivitySectionType.MAIN_INFO].isDone}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.ACTION &&
                    !sectionMap[NewActivitySectionType.ACTION].isHide && (
                        <SectionBox
                            title={intl.formatMessage({
                                id: 'modals.new.activity.section.action',
                                defaultMessage: 'Action',
                            })}>
                            {form.subType?.type?.value !== SmartlyActionSubtypes.PICTURE_MGMT && (
                                <Action
                                    section={sectionMap[NewActivitySectionType.ACTION]}
                                    questionList={questionList}
                                    onSave={() => onSectionSave(NewActivitySectionType.ACTION)}
                                    onAction={onAction}
                                />
                            )}
                            {form.subType?.type?.value === SmartlyActionSubtypes.PICTURE_MGMT && (
                                <PhotographicTaskAction
                                    numberOfPhotos={
                                        form[NewActivitySectionType.ACTION]?.numberOfPhotos
                                    }
                                    onChangeNumber={onChangeNumber}
                                />
                            )}
                        </SectionBox>
                    )}
                {step === NewActivitySectionType.DISTRIBUTION && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.distribution',
                            defaultMessage: 'Distribution',
                        })}>
                        <DistributionList
                            form={form.distribution}
                            onSetForm={(form) => onDistributionChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.DISTRIBUTION)}
                            smartFilter={smartFilter}
                            setSmartFilter={setSmartFilter}
                            tableConfigId={'new_activity_task'}>
                            {(form[NewActivitySectionType.TASK_TYPE].type?.value ===
                                TaskSubType.SERVICE_REQUEST ||
                                !!form.subType?.photoType) && (
                                <DistributionApprovers
                                    form={form.distribution}
                                    onChangeForm={(form: DistributionForm) =>
                                        onDistributionChange(form)
                                    }
                                    selectedRecipients={form.mainInfo.recipient?.value}
                                    taskSubType={
                                        form[NewActivitySectionType.TASK_TYPE].type?.value ===
                                        'serviceRequest'
                                            ? TaskSubType.SERVICE_REQUEST
                                            : form.subType?.photoType
                                    }
                                />
                            )}
                        </DistributionList>
                    </SectionBox>
                )}
                {step === NewActivitySectionType.POINTS_ASSIGNMENT && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.points.assignment',
                            defaultMessage: 'Points Assignment',
                        })}>
                        <PointsAssignments
                            form={form.pointsAssignment}
                            storeIds={
                                form[NewActivitySectionType.DISTRIBUTION].selectedStoreList.value
                            }
                            onSetForm={onPointsAssignment}
                            isDone={sectionMap[NewActivitySectionType.POINTS_ASSIGNMENT].isDone}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.SCHEDULING && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.scheduling',
                            defaultMessage: 'Scheduling',
                        })}>
                        <TaskScheduling
                            form={form[NewActivitySectionType.SCHEDULING]}
                            onSetForm={(form) => onSchedulingChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.SCHEDULING)}
                            isDone={sectionMap[NewActivitySectionType.SCHEDULING].isDone}
                        />
                    </SectionBox>
                )}
            </SectionContainer>
            <DialogDuplicate
                dialogVisible={showDuplicateDialog}
                onSave={onDuplicateConfirm}
                onHide={() => setShowDuplicateDialog(false)}
            />
            <DialogHistoryChange
                dialogVisible={showHistoryChangeDialog}
                onHide={() => setShowHistoryChangeDialog(false)}
                changeFields={changeFields}
                timezone={projectDetails?.timeZone}
            />
            {isResetMandatory && (
                <DialogResetStore
                    dialogVisible={isResetMandatory}
                    onHide={() => setResetMandatory(false)}
                    onSave={(confirm) => handlerEditProject(confirm)}
                    changeFields={changeFields}
                    storesList={getEditSelectedStoreList(
                        form.distribution.selectedStoreList.value,
                        projectDetails
                    )}
                    timezone={projectDetails?.timeZone}
                />
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    sectionMap: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].taskActivity.sectionMap,
    form: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE][ActivitySection.TASK_ACTIVITY].form,
    projectVisibilityOptions:
        state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].projectVisibilityOptions,
    questionList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].questionList,
    taskList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].taskList,
    surveyList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].surveyList,
    isEdit: state.layoutReducer.modals.props?.isEdit,
    isClone: state.layoutReducer.modals.props?.isClone,
    storeIdList: state.layoutReducer.modals.props?.storeIds,
    changeFields: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].changeFields,
    isResetMandatory: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].isResetMandatory,
    activityTypeList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].activityTypeList,
    storesList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].storesList,
    smartFilter: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].smartFilter,
    projectDetails: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].projectDetails,
})

const mapDispatchToProps = (dispatch: any) => ({
    setActivitySectionStatus: (
        activityKey: string,
        sectionKey: NewActivitySectionType,
        section: Partial<ActivityStep>
    ) => dispatch(setActivitySectionStatus(activityKey, sectionKey, section)),
    setForm: (form: TaskForm, section: NewActivitySectionType, activityName: ActivitySection) =>
        dispatch(setNewActivityForm<TaskForm>(form, section, activityName)),
    setCtaTemplate: (template) => dispatch(setCtaTemplate(template)),
    setActionTaskList: (index: number, task: Partial<Task>) => dispatch(setTaskStatus(index, task)),
    setActionSurveyList: (index: number, survey: Partial<Survey>) =>
        dispatch(setSurveyStatus(index, survey)),
    addChangelog: (changelog: Record<string, string>) => dispatch(addChangelog(changelog)),
    removeChangelog: (field: string) => dispatch(removeChangelog(field)),
    createProject: (
        form: ProjectApiCreateActivityBody,
        successMessage: string,
        errorMessage: string
    ) => dispatch(createProject(form, successMessage, errorMessage)),
    saveAsToBeReleased: (projectId: string, successMessage: string, storeIdList) =>
        dispatch(saveAsToBeReleased(projectId, successMessage, storeIdList)),
    cancelProject: (projectId: string, successMessage: string) =>
        dispatch(cancelProject(projectId, successMessage)),
    historyChange: (
        newProject: any,
        invokeEditApi?: boolean,
        reasonChoice?: string[],
        reasonChange?: string,
        messageStores?: string,
        successMessage?: string,
        statusAction?: string
    ) =>
        dispatch(
            historyChange(
                newProject,
                invokeEditApi,
                reasonChoice,
                reasonChange,
                messageStores,
                successMessage,
                statusAction
            )
        ),
    editProject: (
        newProject: any,
        reasonChoice: string[],
        reasonChange: string,
        messageStores: string,
        successMessage: string,
        statusAction?: string
    ) =>
        dispatch(
            editProject(
                newProject,
                reasonChoice,
                reasonChange,
                messageStores,
                successMessage,
                statusAction
            )
        ),
    setResetMandatory: (value: boolean) => dispatch(setResetMandatory(value)),
    setSmartFilter: (value: any) => dispatch(setSmartFilterActivity(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewActivityTask)
